// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_loaderContainer__19ipN","loader":"Loader_loader__1j2Bs"};